import React from 'react';
import useRole from '../../../hooks/use-role';
import { cn } from '../../../utils/cn';
import { formatChatTime, organizationLabel } from '../utils';
import StatusBadge from './StatusBadge';
import UnreadBadge from './UnreadBadge';

const ThreadItem = ({ item, selected, onSelect }) => {
  const { isMeridianOrg } = useRole();

  return (
    <button
      type="button"
      onClick={() => onSelect(item.id)}
      className={cn('flex w-full flex-col gap-1 border-b border-gray-100 px-3 py-3 text-left hover:bg-orange-50', selected && 'bg-orange-50')}>
      <div className="flex items-start gap-2">
        <span className={cn('min-w-0 flex-1 truncate text-sm text-gray-900', item.unread_count > 0 && 'font-semibold')}>{item.user?.fio || 'Без имени'}</span>
        <UnreadBadge count={item.unread_count} />
      </div>

      {isMeridianOrg ? <span className="truncate text-xs text-gray-500">{organizationLabel(item.organization)}</span> : null}

      <span className="truncate text-sm text-gray-600">{item.last_message?.preview || 'Нет сообщений'}</span>

      <div className="flex items-center gap-2">
        <StatusBadge status={item.status} />
        <span className="truncate text-xs text-gray-400">{item.assignee?.fio || ''}</span>
        <span className="ml-auto shrink-0 text-xs text-gray-400">{formatChatTime(item.last_message?.created_at || item.updated_at)}</span>
      </div>
    </button>
  );
};

export default ThreadItem;
